import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './auth/login/Login';
import Auth from './auth/Auth';
import ProtectedRoute from './util/ProtectedRoute';
import Home from './portal/home/Home';
import DaftarRegistrasiPasien from './portal/daftarregistrasipasien/DaftarRegistrasiPasien';
import RekamMedis from './portal/rekammedis/RekamMedis';
import 'bootstrap/dist/css/bootstrap.min.css';
import LaporanClaim from './portal/laporanclaim/LaporanClaim';
import RekapClaim from './portal/rekapclaim/RekapClaim';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <BrowserRouter basename={'/'}>
        <Routes>
            <Route path='/auth' element={<Auth />}>
                <Route path='login' element={<Login />} />
            </Route>
            <Route path="/" element={<App />}>
                <Route path='' element={
                    <ProtectedRoute>
                        <Home />
                    </ProtectedRoute>
                } />
                <Route path='daftar-registrasi-pasien' element={
                    <ProtectedRoute>
                        <DaftarRegistrasiPasien/>
                    </ProtectedRoute>
                } />
                <Route path='rekam-medis' element={
                    <ProtectedRoute>
                        <RekamMedis/>
                    </ProtectedRoute>
                } />
                <Route path='laporan-claim' element={
                    <ProtectedRoute>
                        <LaporanClaim/>
                    </ProtectedRoute>
                } />
                <Route path='rekap-claim' element={
                    <ProtectedRoute>
                        <RekapClaim/>
                    </ProtectedRoute>
                } />
            </Route>
        </Routes>
    </BrowserRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
